import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  root: {
    justifyContent: 'space-between',
    paddingLeft: '30px',
    paddingRight: '30px',
  },
})

export default styleOverride
